export default __webpack_public_path__ + "static/media/file.7c5a2c02.svg";